export default "assets/images/map_mobile_usa-0deefd30.jpg";